
<b-modal
  id="addAbb"
  size="lg"
  :modal-class="addModalClass"
  hide-footer
  hide-header
  hide-backdrop
  no-fade
  @show="showModal"
  @hide="closeModal"
  ref="addabbmodal"
>
  <b-row>
    <b-form
      inline
      @keydown.enter="onSubmit"
      @keydown.113="nextList"
      autocomplete="off"
    >
      <b-form-input
        v-model="form.abb"
        id="abb"
        size="lg"
        class="mb-2 mb-sm-0"
        placeholder="Förkortning"
        autofocus
        ref="abbInput"
        :state="exists"
        @input="checkExists"
      />

      <b-form-datalist id="abb" />
      <b-form-input
        v-model="form.word"
        id="word"
        size="lg"
        class="mb-2 mr-sm-2 mb-sm-0"
        placeholder="Text"
        ref="wordInput"
      />
      <b-form-select
        v-model="form.selected"
        size="lg"
        style="width: 285px"
        ref="listSelect"
        disabled
      >
        <option
          :style="listColorID"
          v-for="list in form.lists"
          :value="list.id"
          :key="list.id"
        >
          {{ list.name }}
        </option>
      </b-form-select>
      <b-button type="submit" style="display: none" />
    </b-form>
    <div style="position: relative">
      <span v-if="existing" class="text-danger">
        <small>existerar som: {{ existing }}</small>
      </span>
      <span
        v-if="form.lists.length > 1"
        class="float-right"
        style="position: relative; right: 10px"
      >
        <small>
          Växla lista med
          <kbd>F2</kbd>
        </small>
      </span>
    </div>
  </b-row>
</b-modal>
